import { Route } from 'react-router-dom';
import { routes } from '../../utils/helpers/ApiClient';
import CMSWrapper from '../CMSWrapper';
import {
  FijJobsPage,
  FijDetailPage,
  FijEdit,
  FijInterestEdit,
  FijInterestedPage,
  FijListMyInterestsPage,
  FijInterestDetailPage,
} from '../pages/CMSPages/index';
import React from 'react';

const FriInternalJobsRoutes = () => (
  <>
    <Route
      path={routes.cmsFijJobs}
      element={
        <CMSWrapper>
          <FijJobsPage />
        </CMSWrapper>
      }
    />

    <Route
      path={`${routes.cmsFijJobDetail}/:id`}
      element={
        <CMSWrapper>
          <FijDetailPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsFijJobEdit}/:id`}
      element={
        <CMSWrapper permissions={['fri-internal-jobs-jobs.update']}>
          <FijEdit />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsFijJobCreate}
      element={
        <CMSWrapper permissions={['fri-internal-jobs-jobs.store']}>
          <FijEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsFijInterestedStudents}/:id`}
      element={
        <CMSWrapper permissions={['fri-internal-jobs-jobs.store']}>
          <FijInterestedPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsFijInterestsCreate}/:job_id`}
      element={
        <CMSWrapper permissions={['fri-internal-jobs-interests.store']}>
          <FijInterestEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsFijInterestsCreate}/:job_id/fromList`}
      element={
        <CMSWrapper permissions={['fri-internal-jobs-interests.store']}>
          <FijInterestEdit mode={'create'} fromList={true} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsFijJobInterestsEdit}/:id`}
      element={
        <CMSWrapper permissions={['fri-internal-jobs-interests.update']}>
          <FijInterestEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsFijJobListOfMyInterests}`}
      element={
        <CMSWrapper permissions={['fri-internal-jobs-interests.index']}>
          <FijListMyInterestsPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsFijInterestedStudents}/:jobId/interest/:id`}
      element={
        <CMSWrapper permissions={['fri-internal-jobs-interests.show']}>
          <FijInterestDetailPage />
        </CMSWrapper>
      }
    />

    {/* keep existing standalone detail route for backwards-compat */}
    <Route
      path={`${routes.cmsFijInterestDetail}/:id`}
      element={
        <CMSWrapper permissions={['fri-internal-jobs-interests.show']}>
          <FijInterestDetailPage />
        </CMSWrapper>
      }
    />
  </>
);

export default FriInternalJobsRoutes;
